// extracted by mini-css-extract-plugin
export default {"course":"Course_course__GxEPe","courseImg":"Course_courseImg__aYCxb"};